import { render, staticRenderFns } from "./roundIntro.vue?vue&type=template&id=71328e4e&scoped=true&"
import script from "./roundIntro.vue?vue&type=script&lang=js&"
export * from "./roundIntro.vue?vue&type=script&lang=js&"
import style0 from "./roundIntro.vue?vue&type=style&index=0&id=71328e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71328e4e",
  null
  
)

export default component.exports